import { FunctionComponent } from 'react';

interface IconProps {
  image: string;
  className?: string;
}

const Icon: FunctionComponent<IconProps> = ({ image, className = '' }: IconProps) => {
  return (
    <i className={className}>
      <style jsx>{`
        i {
          background-image: url(${image});
          background-size: cover;
          width: 24px;
          height: 24px;
          margin-right: 10px;
        }
      `}</style>
    </i>
  );
};

export default Icon;
